import { Component, OnInit } from '@angular/core';
import { UtilsModule } from '@otas/utils/utils.module';
import { UserInfoWrapperComponent } from 'app/user-info-wrapper/user-info-wrapper.component';
@Component({
  selector: 'app-temple-address',
  templateUrl: './temple-address.component.html',
  styleUrls: ['./temple-address.component.css'],
  imports: [UtilsModule, UserInfoWrapperComponent]
})
export class TempleAddressComponent implements OnInit {
  templeOwner = false;
  user;
  constructor() { }

  ngOnInit() {
    this.user = JSON.parse(sessionStorage.getItem('CURRENT_USER'));
    this.user.roles.forEach(element => {
      if (element.name === 'FULL_ACCESS') {
        this.templeOwner = true;
      }
    });
  }

}
